/**
 * Placeholders for Email Triggers templates (must match backend emailTriggerPlaceholders.cjs).
 * Tokens are inserted as {{token}}. On send, the API uses the projects row and falls back to
 * Project Summary ACF when a spreadsheet column is empty (e.g. mrc ← monthly_recurring_charge).
 */

/** @type {{ token: string, label: string, group: string }[]} */
export const EMAIL_TRIGGER_PLACEHOLDER_FIELDS = [
  { token: "project_id", label: "Project ID", group: "Project" },
  { token: "project_name", label: "Project name", group: "Project" },
  { token: "work_order", label: "Work order", group: "Project" },
  { token: "work_order_base", label: "Work order (parent)", group: "Project" },
  { token: "export_slug", label: "Export slug", group: "Project" },
  { token: "legacy_wp_post_id", label: "Legacy WP post ID", group: "Project" },

  { token: "customer", label: "Customer", group: "Customer & status" },
  { token: "project_type", label: "Project type", group: "Customer & status" },
  { token: "subtype", label: "Subtype", group: "Customer & status" },
  { token: "status", label: "Status", group: "Customer & status" },
  { token: "phase_label", label: "Phase label", group: "Customer & status" },
  { token: "phase_slug", label: "Phase slug", group: "Customer & status" },
  { token: "phase_expansion_slug", label: "Phase expansion slug", group: "Customer & status" },
  { token: "subphase", label: "Subphase slug", group: "Subphase" },
  { token: "subphase_label", label: "Subphase label", group: "Subphase" },
  { token: "subphase_phase", label: "Subphase phase", group: "Subphase" },
  { token: "subphase_previous", label: "Previous subphase", group: "Subphase" },

  { token: "service_location", label: "Service location", group: "Location" },
  { token: "site_name", label: "Site name", group: "Location" },
  { token: "a_location", label: "A location", group: "Location" },
  { token: "z_location", label: "Z location", group: "Location" },

  { token: "service_speed", label: "Service speed", group: "Networking" },
  { token: "circuit_id", label: "Circuit ID", group: "Networking" },

  { token: "sales_rep", label: "Sales representative", group: "People" },

  { token: "invoiced_date", label: "Invoiced date", group: "Dates" },
  { token: "foc_date", label: "FOC date", group: "Dates" },
  { token: "created_at", label: "Created at", group: "Dates" },

  { token: "mrc", label: "MRC", group: "Financial" },
  { token: "non_recurring_charge", label: "Non-recurring charge", group: "Financial" },
  { token: "term_in_months", label: "Term (months)", group: "Financial" },

  { token: "site_walk", label: "Site walk", group: "Flags" },
  { token: "numbers_complete", label: "Numbers complete", group: "Flags" },
  { token: "countersigned", label: "Countersigned", group: "Flags" },
  { token: "new_customer", label: "New customer", group: "Flags" },
  { token: "cvin_expansion", label: "CVIN expansion", group: "Flags" },
  { token: "incident", label: "Incident", group: "Flags" },
  { token: "multisite", label: "Multisite", group: "Flags" },

  { token: "project_notes", label: "Project notes", group: "Notes" },

  { token: "permit_agency", label: "Permit agency", group: "Permits" },
  { token: "permit_number", label: "Permit number", group: "Permits" },
  { token: "permit_expiration_date", label: "Permit expiration date", group: "Permits" },
  { token: "permit_line_label", label: "Permit / rider line label", group: "Permits" },
  { token: "days_until_expiration", label: "Days until expiration", group: "Permits" },
  { token: "permit_rider_type", label: "Rider / amendment type", group: "Permits" },
  { token: "permit_rider_description", label: "Rider description", group: "Permits" },
  { token: "permit_rider_label", label: "Rider label", group: "Permits" },
  { token: "permit_rider_number", label: "Rider number (within permit)", group: "Permits" },
  { token: "permit_rider_summary", label: "Rider summary (agency — type)", group: "Permits" },
];

export function placeholderTokenMarkup(token) {
  return `{{${token}}}`;
}

/** Grouped options for &lt;select optgroup&gt;. */
export function emailPlaceholderSelectGroups() {
  const byGroup = new Map();
  for (const f of EMAIL_TRIGGER_PLACEHOLDER_FIELDS) {
    if (!byGroup.has(f.group)) byGroup.set(f.group, []);
    byGroup.get(f.group).push(f);
  }
  return [...byGroup.entries()].map(([group, fields]) => ({ group, fields }));
}
